import { render, staticRenderFns } from "./itemlist.vue?vue&type=template&id=27e63605&scoped=true&"
import script from "./itemlist.vue?vue&type=script&lang=js&"
export * from "./itemlist.vue?vue&type=script&lang=js&"
import style0 from "./itemlist.vue?vue&type=style&index=0&id=27e63605&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e63605",
  null
  
)

export default component.exports